module.exports = __webpack_public_path__ + "static/media/phone.37be2015.svg";